import React from 'react';
import { ChevronRight } from 'lucide-react';
export function CourseHeader() {
  return <div className="mb-8" data-id="element-16">
      {/* Breadcrumbs */}
      <nav className="flex items-center gap-2 text-sm text-gray-500 mb-4" data-id="element-17">
        <div className="w-6 h-6 rounded-full bg-indigo-600 text-white flex items-center justify-center text-xs font-bold" data-id="element-18">
          C
        </div>
        <span data-id="element-19">/</span>
        <span className="hover:text-gray-900 cursor-pointer" data-id="element-20">Courses</span>
        <span data-id="element-21">/</span>
        <span className="text-gray-900" data-id="element-22">Heavy Rigid Class</span>
      </nav>

      {/* Title */}
      <h1 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-23">
        Heavy Rigid Class
      </h1>

      {/* Metadata */}
      <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-gray-600" data-id="element-24">
        <div className="flex items-center gap-2" data-id="element-25">
          <span data-id="element-26">Status:</span>
          <span className="font-semibold text-gray-900" data-id="element-27">Draft</span>
        </div>
        <div data-id="element-28">
          Last Modified:{' '}
          <span className="text-gray-900" data-id="element-29">January 14th 2026, 2:41 PM</span>
        </div>
        <div data-id="element-30">
          Created:{' '}
          <span className="text-gray-900" data-id="element-31">October 21st 2025, 12:17 PM</span>
        </div>
      </div>
    </div>;
}